import { Grid, Typography } from "@mui/material";
import styles from "./styles";

const SectionHeader = ({ title, description }) => {
  return (
    <Grid
      container
      direction={"column"}
      alignItems="center"
      mt={{ xs: 3, md: 5 }}
      textAlign="center"
    >
      <Typography component="h1" sx={styles.titleSx}>
        {title}
      </Typography>

      <Typography component="p" sx={styles.descriptionSx}>
        {description}
      </Typography>
    </Grid>
  );
};

export default SectionHeader;
